import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig';
import { doc, updateDoc } from 'firebase/firestore';
import './EditReservationModal.css';

function EditReservationModal({ reservation, onClose, onSave }) {
  const [formData, setFormData] = useState({ ...reservation });

  useEffect(() => {
    setFormData({ ...reservation });
  }, [reservation]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const reservationRef = doc(db, 'reservations', reservation.id);
      await updateDoc(reservationRef, formData);
      onSave(formData);
      onClose();
    } catch (error) {
      console.error('Error updating reservation:', error);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Editar Reservación</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Sede</label>
            <input type="text" name="sede" value={formData.sede} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Comensales</label>
            <input type="number" name="guests" value={formData.guests} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Fecha</label>
            <input type="date" name="date" value={formData.date} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Hora</label>
            <input type="time" name="time" value={formData.time} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Nombre</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} />
          </div>
          <div className="modal-actions">
            <button type="submit" className="save-button">Guardar</button>
            <button type="button" className="cancel-button" onClick={onClose}>Cancelar</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditReservationModal;
